import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-40'],
    padding: {
      default: `${anatomy['size-32']} ${anatomy['size-40']}`,
      '@media (max-width: 767px)': `${anatomy['size-32']} 16px`,
    },
    backgroundColor: palette['grey-950'],
    borderRadius: anatomy.borderRadiusM,
    border: `1px solid ${palette['lighted-10']}`,
  },
  draggableItem: {
    cursor: 'grab',
  },
  previewContainer: {
    width: '100%',
    alignItems: 'center',
    backgroundColor: palette['grey-950'],
  },
  loadingContainer: {
    flexGrow: 1,
  },
  loader: {
    position: 'absolute',
    inset: 0,
    zIndex: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  draggableItemDragging: {
    cursor: 'grabbing',
  },
  containerPreview: {
    width: '500px',
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-40'],
  },
});
